<template>
    <div class="camera-row-item" :id= "item.subjectName">
        <div class="detail-title-panel">
            <div class="md-d-inline sm-d-block subject-info">
                <input type="hidden" :value="item.id" ref="itemId" />
                <span class="title"><strong>{{ item.subjectName }}</strong></span>
                <el-tag v-show="item.documentStatusForDisplay !== ''" style="margin-left: 6px; margin-right: 6px" :type="item.documentStatusForDisplay === 'ご提供待ち' || item.documentStatusForDisplay === '再提供依頼中' ? 'warning' : ''">{{ item.documentStatusForDisplay }}</el-tag>
            </div>
            <div class="md-d-inline sm-d-block" style="float: right">
                <el-button class="btn-scroll-menu" icon="el-icon-menu" @click="scrollMenuSubject(item)">一覧に戻る</el-button>
                <el-button type="primary" icon="el-icon-upload" @click="showDialog" v-if="!disabledByAnkenStatus(item.categoryId)">ファイルから選択</el-button>
                <div class="image-upload" v-if="isMobile && !disabledByAnkenStatus(item.categoryId)">
                    <label :for="['file-input-' + item.id]">
                        <i class="el-icon-camera"> 写真を撮る</i>
                    </label>

                    <input
                            :id="['file-input-' + item.id]"
                            type="file"
                            accept="image/*"
                            capture
                            ref="fileInput"
                            @change="handlePreviewImage($event, item.id)"
                    />
                </div>
            </div>
        </div>
        <div class="detail-document-panel" v-if="item.disclosureFlag">
            <div class="detail-document-card" style="width: 100px; height:200px; margin-bottom: 10px;" v-if="checkFile(item) && item.documentNumber == 1"
                 @click="previewImage(require('@/images/camera/' + item.categoryId +'_' + item.subjectId + '.jpg'))">
                <img v-lazy="require('@/images/camera/' + item.categoryId +'_' + item.subjectId + '.jpg')" alt="サンプル" width="100px" height="120px" class="document-card-image" :id="'sample_img_' + item.categoryId +'_' + item.subjectId">
                <div class="update-user-name">
                    サンプル
                </div>
            </div>
            <div class="detail-document-card" v-for="document in item.files" :key="document.id">
                <div style="width: 100px; margin-bottom: 10px;">
                    <div @click="previewImage(document.fileSingedUrl)" v-if="!document.fileSingedUrl.includes('.pdf')">
                        <img v-lazy="document.thumbnailImageSignedUrl || document.fileSingedUrl" :alt="document.fileName" width="100px" height="120px" class="document-card-image" :id="'img_' + document.id">
                    </div>
                    <img @click="previewPDF(document.fileSingedUrl)" v-lazy="require('@/images/camera/pdf_sample.png')" :alt="document.fileName" width="100px" height="120px" v-else>
                    <div class="update-user-name">
                        {{ document.uploadUserName }}
                    </div>
                    <el-button v-if="!isFinishedAnken && document.legacyUse === false && item.documentStatusForDisplay !== '提供完了' && document.updatedBy === currentUser.id && document.updatedRole === '[ROLE_MEMBER]'" type="danger" @click="handleDeleteDialog(document.spDocumentId, document.id)">削除</el-button>
                    <!-- <el-button v-else size="mini" type="danger" icon="el-icon-check" circle></el-button> -->
                </div>
            </div>
        </div>

        <!-- Dialog Upload -->
        <el-dialog
            :visible.sync="dialogVisible"
            :show-close="false"
            :close-on-click-modal="false"
            :destroy-on-close="true"
            width="30%">
            <el-form
                class="upload-form"
                ref="uploadForm"
                @submit.native.prevent="submitForm()"
                label-width="120px"
                >
                <div class="messages">
                    <p>アップロードするファイルを選択してください</p>
                    <p class="error">{{ this.messages }}</p>
                </div>
                <div class="input-file-container">
                    <input class="input-file" id="my-file" type="file" ref="file" @change="handleChangeFileUpload" accept=".pdf,.jpg,.jpeg,.png,.gif">
                    <label tabindex="0" for="my-file" class="input-file-trigger">ファイルを選択する</label>
                </div>
                <p class="file-return">{{ fileName }}</p>
                <div class="button-panel-left">
                    <el-button type="danger" @click="handleCancelUploadDialog">キャンセル</el-button>
                    <el-button type="primary" class="button-right" :loading="loading" v-show="!isFileEncoding" native-type="submit">アップロード</el-button>
                    <el-button class="button-right is-loading" type="primary" v-show="isFileEncoding" :disabled="true">
                        <i class="el-icon-loading" style="margin-right: 5px;"></i>読み込み中
                    </el-button>
                </div>
            </el-form>
        </el-dialog>

        <!-- Dialog Upload Camera -->
        <el-dialog
            :visible.sync="dialogCameraVisible"
            :show-close="false"
            :close-on-click-modal="false"
            :destroy-on-close="true"
            width="30%">
            <div class="messages">
                <p>続けて写真をとりますか？</p>
                <p class="error">{{ this.messages }}</p>
            </div>
            <div class="button-panel">
                <el-button type="danger" @click="handleCancelDialogCamera">やり直す</el-button>
                <el-button type="danger" @click="$refs.fileInput.click()">続けて撮る</el-button>
                <el-button type="danger" @click="dialogUploadImageVisible = true">写真を提供する</el-button>
            </div>
        </el-dialog>

        <!-- Dialog Upload Image -->
        <el-dialog
            :visible.sync="dialogUploadImageVisible"
            :show-close="false"
            :close-on-click-modal="false"
            :destroy-on-close="true"
            width="30%">
            <div class="messages">
                <p>送信する写真を選択してください</p>
            </div>
            <div class="detail-document-panel" v-if="!isLoadingUpload">
                <div class="detail-document-card" v-for="(file, index) in getPreviewFile" :key="index">
                    <div style="width: 100px; height:150px; margin-bottom: 10px;">
                        <img v-lazy="file.previewUrl" width="100px" height="150px">
                    </div>
                    <el-checkbox v-model="previewFiles[index]" :checked="true"></el-checkbox>
                </div>
            </div>
            <div v-if="isLoadingUpload" class="panel loading-panel" style="text-align: center; padding-top: 50px;">
                <img src="@/assets/images/loading.gif" alt="loading">
            </div>
            <div class="button-panel" v-if="!isLoadingUpload">
                <el-button type="danger" @click="dialogUploadImageVisible = false">戻る</el-button>
                <el-button type="danger" @click="uploadMultiPreviewFiles">写真を提供する</el-button>
            </div>
        </el-dialog>

        <!-- Dialog Delete Image -->
        <el-dialog
            :visible.sync="dialogDeleteImageVisible"
            :show-close="false"
            :close-on-click-modal="false"
            :destroy-on-close="true"
            width="30%">
            <div class="messages">
                <p>削除します。よろしいですか？</p>
            </div>
            <div class="button-panel-left" style="margin-top: 10px;">
                <el-button type="danger" @click="dialogDeleteImageVisible = false">キャンセル</el-button>
                <el-button type="primary" class="button-right" @click="handleClickDeleteButton(deleteForm.spDocumentId, deleteForm.id)"
                        :loading="deleteForm.loading">削除する</el-button>
            </div>
        </el-dialog>
        <!-- Image Preview -->
        <div class="image-preview">
            <el-dialog
                :visible.sync="dialogImagePreview"
                :show-close="true"
                :destroy-on-close="true"
                :before-close="beforeCloseImagePreview"
                width="30%">
                <div style="margin-bottom: 10px; margin-top: 20px; text-align: center; max-height: 70vh">
                    <img :src="previewImageUrl" width="100%" style="max-height: 70vh">
                </div>
            </el-dialog>
        </div>

        <!-- PDF Preview -->
        <div class="image-preview">
            <el-dialog
                :visible.sync="dialogFilePreview"
                :show-close="true"
                :destroy-on-close="true">
                <div v-if="isMobile || isIE" style="margin-bottom: 10px; margin-top: 20px;">
                    <pdfjs v-if="dialogFilePreview" :src="previewFileUrl" :height="450"></pdfjs>
                </div>
                <div v-else style="margin-bottom: 10px; margin-top: 20px; text-align: center">
                    <iframe class="iframe-file" :src="previewFileUrl" type="application/pdf" title="PDF file" width="100%" height="600px"></iframe >
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CameraClientApi from '@/api/camera/camera-client.js'
import DocumentApi from '@/api/document/document.js'
import { isMobile } from 'mobile-device-detect'
import Compressor from 'compressorjs'
import { SET_PREVIEW_FILE, DESTROY_PREVIEW_FILE } from '@/store/actions.type'
import Pdfjs from '../../../../components/pdfjs/Pdfjs'
import { isIE } from '@/common/useragent'
import objectFitImages from 'object-fit-images'
import { validateFileSize } from '@/validate/validate-common'

export default {
    name: 'camera-row-item',
    props: ['item', 'isFinishedAnken'],
    data () {
        return {
            isMobile: isMobile,
            dialogVisible: false,
            dialogCameraVisible: false,
            dialogUploadImageVisible: false,
            dialogDeleteImageVisible: false,
            loading: false,
            messages: '',
            error: '',
            file: null,
            fileName: '',
            base64URI: '',
            previewFiles: {},
            fileUploadName: '',
            isLoadingUpload: false,
            deleteForm: {
                loading: false,
                spDocumentId: null,
                id: null
            },
            dialogImagePreview: false,
            previewImageUrl: null,
            dialogFilePreview: false,
            previewFileUrl: null,
            scr: null,
            numPages: undefined,
            isFileEncoding: false,
            thumbnailImageSignedUrl: []
        }
    },
    components: { Pdfjs },
    computed: {
        ...mapGetters(['getPreviewFile', 'getDocumentId', 'currentUser']),
      isIE () {
          return isIE()
      }
    },
    mounted () {
        if (isIE()) {
            this.$Lazyload.$on('loaded', function ({ bindType, el, naturalHeight, naturalWidth, $parent, src, loading, error }, formCache) {
                objectFitImages('#' + el.id)
            })
        }
    },
    methods: {
        disabledByAnkenStatus (categoryId) {
            if (this.isFinishedAnken) {
                return categoryId !== 5
            }
            return false
        },
        previewImage (url) {
            this.previewImageUrl = url
            this.dialogImagePreview = true
            if (isIE()) {
                this.$nextTick(() => {
                    objectFitImages('.image-preview img')
                })
            }
        },
        beforeCloseImagePreview () {
            this.previewImageUrl = null
            this.dialogImagePreview = false
        },
        previewPDF (url) {
           this.previewFileUrl = url
           this.dialogFilePreview = true
        },
        async handleChangeFileUpload (event) {
            let files = this.$refs.file.files
            if (files.length) {
                const isValid = validateFileSize(files[0], 30)

                if (!isValid) {
                    this.fileName = ''
                    this.file = null
                    this.base64URI = ''
                    // clear file input
                    event.target.value = ''
                    this.$message.error(this.$t('rules.over_upload'))
                } else {
                    this.isFileEncoding = true
                    this.messages = ''
                    this.file = files[0]
                    this.fileName = files[0].name
                    this.base64URI = await this.getBase64(this.file)
                    this.isFileEncoding = false
                }
            } else {
                this.fileName = ''
                this.messages = ''
            }
        },
        getBase64 (file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })
        },
        async submitForm () {
            let files = this.$refs.file.files
            if (!files.length) {
                this.messages = 'ファイルが見つかりません'
                this.fileName = ''
            } else {
                let fileType = this.$refs.file.files[0]['type']
                const validImageTypes = ['image/gif', 'image/jpeg', 'image/png', 'application/pdf']
                if (!validImageTypes.includes(fileType)) {
                    this.messages = 'ファイルのフォーマットが不正です。'
                } else {
                    const payloadUpload = {
                        spDocumentId: this.item.id,
                        base64URI: this.base64URI
                    }
                    this.loading = true
                    let documentUpload = await CameraClientApi.uploadFile(payloadUpload)

                    // const newDocumentUpload = documentUpload.data.result
                    const payload = {
                        filePath: documentUpload.data.result.filePath
                    }
                    await DocumentApi.getSignedUrl(payload).then((response) => {
                        if (response.data.code === 200) {
                            this.loading = false
                            this.dialogVisible = false
                            this.fileName = ''
                            this.fileSingedUrl = response.data.signedUrl
                            // Object.assign(newDocumentUpload, { 'fileSingedUrl': this.fileSingedUrl }, { 'uploadUserName': this.currentUser.lastName + this.currentUser.firstName })
                            // this.item.files.push(newDocumentUpload)
                            // if (newDocumentUpload.documentStatusForDisplay !== '') {
                            //     this.item.documentStatusForDisplay = newDocumentUpload.documentStatusForDisplay
                            // }
                        }
                    })
                    .catch(err => {
                        this.loading = false
                        throw err
                    })
                    // this.callGetSignedUrlWithThumbnailFilePath(newDocumentUpload, documentUpload)
                    this.refreshData()
                }
            }
        },
        async callGetSignedUrlWithThumbnailFilePath (newDocumentUpload, documentUpload) {
            const max = 3
            const prefix = 'Thumbnail_'
            let fileName = documentUpload.data.result.filePath.split('/').reverse()[0]
            let thumbnailFilePath = documentUpload.data.result.filePath.replace(fileName, prefix + fileName)
            const payload2 = {
                filePath: thumbnailFilePath
            }
            // サムネイルは作成に時間がかかり、APIレスポンスが200でないことがあるため、最大max回APIを呼ぶ
            for (let apiResponseSuccess = false, i = 1; !apiResponseSuccess && i <= max; i++) {
                await this.sleep(i)
                await DocumentApi.getSignedUrl(payload2).then((response) => {
                    if (response.data.code === 200) {
                        this.thumbnailImageSignedUrl = response.data.signedUrl
                        Object.assign(newDocumentUpload, { 'fileSingedUrl': this.fileSingedUrl }, { 'uploadUserName': this.currentUser.lastName + this.currentUser.firstName }, { 'thumbnailImageSignedUrl': this.thumbnailImageSignedUrl })
                        this.item.files.push(newDocumentUpload)
                        if (newDocumentUpload.documentStatusForDisplay !== '') {
                            this.item.documentStatusForDisplay = newDocumentUpload.documentStatusForDisplay
                        }
                        apiResponseSuccess = true
                    }
                })
                .catch(err => {
                    this.loading = false
                    throw err
                })
            }
        },
        handleDeleteDialog (spDocumentId, id) {
            this.dialogDeleteImageVisible = true
            this.deleteForm.spDocumentId = spDocumentId
            this.deleteForm.id = id
        },
        handleClickDeleteButton (spDocumentId, id) {
            this.deleteForm.loading = true
            const data = {
                spDocumentId: spDocumentId,
                spUploadManageId: id
            }
            CameraClientApi.deleteFile(data).then(response => {
                if (response.status === 200) {
                    // this.item.files = _.filter(this.item.files, function (obj) {
                    //     return obj.id !== id
                    // })
                    this.clearDeleteForm()
                    this.dialogDeleteImageVisible = false
                    this.refreshData()
                }
            })
            .catch(err => {
                this.clearDeleteForm()
                throw err
            })
        },
        clearDeleteForm () {
            this.deleteForm.loading = false
            this.deleteForm.spDocumentId = null
            this.deleteForm.id = null
        },
        async handlePreviewImage (e, spDocumentId) {
            const file = e.target.files[0]
            if (file) {
                this.dialogCameraVisible = true
                const data = {
                    spDocumentId: spDocumentId,
                    previewFile: {
                        file,
                        previewUrl: URL.createObjectURL(file)
                    }
                }
                this.$store.dispatch(SET_PREVIEW_FILE, data)

                // clear file input
                e.target.value = ''
            }
        },
        handleCancelDialogCamera () {
            this.$store.dispatch(DESTROY_PREVIEW_FILE)
            this.dialogCameraVisible = false
        },
        handleSaveImage ($event) {
            this.$refs.fileInput.click()
            // let spDocumentId = this.$store.getters['getDocumentId']
            // let file = this.$store.getters['getPreviewFile']
            // this.uploadFileForDocument(spDocumentId, file)
        },
        uploadFileForDocument (spDocumentId, file) {
            let _this = this
            if (file) {
                return new Promise((resolve, reject) => {
                    // eslint-disable-next-line no-new
                    new Compressor(file, {
                        quality: 0.4,
                        success (result) {
                            _this.getBase64(result).then(response => {
                                let base64URICompress = response
                                const payloadUpload = {
                                    spDocumentId: spDocumentId,
                                    base64URI: base64URICompress
                                }
                                return CameraClientApi.uploadFile(payloadUpload)
                            })
                            .then(response => {
                                resolve(response)
                            })
                            .catch(err => {
                                reject(err)
                            })
                        },
                        // eslint-disable-next-line handle-callback-err
                        error (err) {
                            reject(err)
                        }
                    })
                })
            } else {
                return Promise.resolve()
            }
        },
        async uploadMultiFile (e, spDocumentId) {
            for (let i = 0; i < this.$refs.multifile.files.length; i++) {
                let file = this.$refs.multifile.files[i]
                let fileType = file['type']
                const validImageTypes = ['image/gif', 'image/jpeg', 'image/png', 'application/pdf']
                if (!validImageTypes.includes(fileType)) {
                    this.messages = 'ファイルのフォーマットが不正です。'
                } else {
                    this.uploadFileForDocument(spDocumentId, file)
                }
            }
        },
        async uploadMultiPreviewFiles () {
            this.isLoadingUpload = true
            let spDocumentId = this.$store.getters['getDocumentId']
            let files = this.$store.getters['getPreviewFile']
            const uploads = files.filter((file, index) => {
                return this.previewFiles[index]
            }).map(file => {
                return this.uploadFileForDocument(spDocumentId, file.file)
            })
            await Promise.all(uploads).then(u => {
                this.$store.dispatch(DESTROY_PREVIEW_FILE)
                this.isLoadingUpload = false
                this.dialogCameraVisible = false
                this.dialogUploadImageVisible = false
                this.refreshData()
            }).catch(err => {
                this.isLoadingUpload = false
                throw err
            })
        },
        handleCancelUploadDialog () {
            this.dialogVisible = false
            this.messages = ''
            this.fileName = ''
        },
        checkFile (item) {
            const fileName = item.categoryId + '_' + item.subjectId + '.jpg'
            try {
                require('@/images/camera/' + fileName)
                return true
            } catch (err) {
                return false
            }
        },
        showDialog () {
            this.dialogVisible = true
            this.$nextTick(() => {
                if (isIE()) {
                    this._$('input[type="file"]').css('pointer-events', 'none')
                    this._$('input[type="file"]').on('focus', event => event.currentTarget.blur())
                }
            })
        },
        scrollMenuSubject (subject) {
            let subjectName = subject.subjectName
            let categoryId = subject.categoryId
            let scrollElmId = ''
            let menuSubjectName = subjectName + '_link'
            let subjectView = document.getElementById(menuSubjectName)
            if (subjectView) {
                if (subjectView.style.display === 'none') {
                    scrollElmId = subjectView.getAttribute('name') // Link to category
                } else {
                    scrollElmId = menuSubjectName
                }
            } else if (categoryId && document.getElementById('category_' + categoryId)) {
                scrollElmId = 'category_' + categoryId
            } else {
                scrollElmId = 'document-list'
            }
            this.$bus.$emit('moveMenuSubject', scrollElmId)
        },
        sleep (sec) {
            return new Promise((resolve, reject) => {
                setTimeout(resolve, sec * 1000)
            })
        },
        refreshData () {
            this.$bus.$emit('refreshCamera')
            this.$bus.$emit('reLoadDocument')
            this.$bus.$emit('reloadAnken')
        }
    }
}
</script>

<style>
.camera-row-item .el-dialog__header {
    padding: 0;
}
.camera-row-item .messages {
    text-align: center;
    font-weight: bold;
}
.camera-row-item .upload-form .file-upload {
    padding: 20px 0;
}
.input-file-container {
  position: relative;
  width: 225px;
  margin-top: 20px;
}
.input-file-trigger {
  display: block;
  padding: 12px 45px;
  background: #39D2B4;
  color: #fff;
  font-size: 1em;
  transition: all .4s;
  cursor: pointer;
}
.input-file {
  position: absolute;
  top: 0; left: 0;
  width: 225px;
  opacity: 0;
  padding: 14px 0;
  cursor: pointer;
}
.input-file:hover + .input-file-trigger,
.input-file:focus + .input-file-trigger,
.input-file-trigger:hover,
.input-file-trigger:focus {
  background: #34495E;
  color: #39D2B4;
}
.file-return {
    margin-bottom: 20px;
}
.camera-row-item .error {
    color: red;
}
.camera-row-item .button-panel {
    width: 100%;
    text-align: center;
    padding-top: 10px;
    margin: 0 auto;
}
.camera-row-item .button-panel .el-button {
    display: inline-block;
    width: 50%;
    margin-bottom: 20px;
    margin-left: 10px;
}
.camera-row-item .button-panel-right {
    width: 100%;
    text-align: left;
}
.camera-row-item .button-panel-left .button-right {
    float: right;
}
.camera-row-item .detail-title-panel {
    padding: 10px;
    padding-right: 0;
    border: 1px solid #e4dec0;
    display: inline-block;
    width: 100%;
    vertical-align: middle;
}
.camera-row-item .detail-title-panel .title {
    line-height: 40px;
}
.camera-row-item .detail-title-panel .el-button {
    /*float: right;*/
    margin-left: 10px;
    margin-right: 4px;
}
.camera-row-item .detail-document-panel {
    width: 100%;
    padding: 30px 10px;
    display: flex;
    flex-wrap: wrap;
}
.camera-row-item .detail-document-card {
    margin: 20px;
    text-align: center;
}
.camera-row-item .detail-document-card img {
    transition: transform .2s;
    object-fit: scale-down;
    font-family: 'object-fit: scale-down;';
}
.image-preview img {
    object-fit: contain;
    font-family: 'object-fit: contain;';
}
.camera-row-item .detail-document-card img:hover {
    cursor: pointer;
    /*transform: scale(1.5);*/
}
.camera-row-item .detail-document-card .update-user-name {
  font-size: 16px;
  margin: 10px 0;
}
.camera-row-item .el-dialog {
    width: 40% !important;
}

@media screen and (max-width:1390px) {
    .camera-row-item .el-dialog {
        width: 60% !important;
    }
    .camera-row-item .el-form-item__label {
        width: 100px !important;
    }
    .camera-row-item .el-form-item__content {
        margin-left: 100px !important;
    }
}

@media screen and (max-width:970px) {
    .camera-row-item .el-dialog {
        width: 75% !important;
    }
}

@media screen and (max-width:768px) {
    .camera-row-item .el-dialog {
        width: 90% !important;
    }
    .btn-scroll-menu {
        float: none !important;
    }
}
@media screen and (max-width:480px) {
    .camera-row-item .el-dialog {
        width: 95% !important;
    }
    .camera-row-item .el-form-item__content {
        margin-left: 0 !important;
    }
}

.camera-row-item .image-upload {
    float: right;
}
.camera-row-item .image-upload > input {
  display: none;
}
.camera-row-item .image-upload label {
    color: #fff;
    background-color: #409eff;
    border-color: #409EFF;
    border: 1px solid #DCDFE6;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;
}
.camera-row-item .multi-image-upload {
    display: inline-block;
    margin-left: 10px;
}
.camera-row-item .multi-image-upload > input {
  display: none;
}
.camera-row-item .multi-image-upload label {
    color: #fff;
    background-color: #a5272a;
    border-color: #a5272a;
    border: 1px solid #DCDFE6;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    padding: 12px 20px 13px;
    font-size: 14px;
    border-radius: 4px;
}
</style>
